@use '@design/design-tokens/typography/typography' as *;

@layer chart {
  .allInsightsRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 16px 12px;
    border-bottom: 1px solid var(--border-soft);
    min-width: 350px;
  }

  .allInsightsLabel {
    @include typography-v2-body-sm;
  }

  .assetList {
    display: flex;
    flex-direction: column;
    max-height: 280px;
    overflow-y: auto;
  }

  .assetRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 16px;
    gap: 12px;
  }

  .checkboxWrapper {
    display: flex;
    align-items: center;
    flex-shrink: 0;

    > div {
      flex-direction: row;
      align-items: center;
    }

    label {
      align-items: center;
    }

    label > div:first-of-type {
      margin-top: 0;
    }
  }

  .entityName {
    @include typography-v2-body-sm;
    color: var(--text-soft);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: right;
    min-width: 0;
    flex: 1;
  }
}
